<template>
  <div class="layout-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
        title="排列"
        name="10"
        v-if="!disableSetColAndRow && !isLoginLayout"
      >
        <div
          class="setting-item clearFloat"
          v-if="
            checkShowTabs('排列') && collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '10')
          "
        >
          <div class="content">
            <div class="mb16" v-if="isLoginEngine">
              <slider-and-input
                inputWidth="small"
                :value.sync="topHeight"
                title="标题栏高度"
                :sliderMax="999"
                :sliderMin="0"
                suffix="px"
              />
            </div>
            <div class="content-item mb16">
              <emptyLayoutComponent :options="options" :isLayout="true" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" title="外观" name="3">
        <div
          class="setting-item"
          v-if="checkShowTabs('外观') && collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
        >
          <div class="content">
            <slider-and-input
              class=""
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <div class="content-item mb16 mt16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb16">
              <div class="mb16">边框</div>
              <div class="ml8">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
            </div>
            <div class="content-item mb16">
              <cx-padding
                v-if="
                  checkShowTabs('边距') &&
                  collapseActiveNames.length !== 0 &&
                  collapseActiveNames.find(it => it === '2')
                "
                :paddingTypeFlag.sync="topNavPaddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
            <div class="content-item mb16">
              <cx-background
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
                :background.sync="background"
                imgType="10"
              />
            </div>
            <div class="content-item">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="5">
        <div class="setting-item">
          <div class="content">
            <div class="setting-item" style="line-height: 18px" v-if="!isLoginLayout && !isLoginEngine">
              <el-checkbox v-model="showScorll">开启滚动</el-checkbox>
            </div>
            <div class="setting-item mt8 card" v-if="!isLoginLayout && showScorll">
              <div class="set-item">
                <span class="title">滚动方式</span>
                <div class="content">
                  <SliderSelect :options="scrollTypeList" :value.sync="scrollTypeVal" :useToolTip="true"></SliderSelect>
                </div>
              </div>
              <div v-if="options.showScorll">
                <div v-if="!singleRowOrColFlag" class="set-item">
                  <span class="title">滚动方向</span>
                  <div class="content">
                    <SliderSelect :options="scrollDirectionList" :value.sync="scrollDirectionVal"></SliderSelect>
                  </div>
                </div>
                <div class="set-item">
                  <p class="font14 title" v-if="scorllType === true">内容宽度</p>
                  <p class="font14 title" v-if="scorllType === 'vertical'">内容高度</p>
                  <slider-and-input
                    inputWidth="large"
                    inputHeight="small"
                    :value.sync="contentWidth"
                    title=""
                    :sliderMin="100"
                    :sliderMax="500"
                    suffix="%"
                  />
                </div>
              </div>
              <div v-else>
                <div class="set-item">
                  <span class="title">切换速度</span>
                  <div class="content">
                    <single-input
                      :value.sync="scrollSpeed"
                      inputSuffixs="ms"
                      :min="1000"
                      :max="20000"
                    />
                  </div>
                </div>
                <div class="set-item">
                  <span class="title">停留时间</span>
                  <div class="content">
                    <single-input
                      :value.sync="waitTime"
                      inputSuffixs="ms"
                      :min="0"
                      :max="4000"
                    />
                  </div>
                </div>
                <cx-check-box :value.sync="hoverStopScroll">鼠标移入时停止滚动</cx-check-box>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="$store.state.states.showPluginSetting"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
        title="插件"
        name="6"
      >
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
    <asyncPluginSettingSubmit
      v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
      :pluginName="options.pluginName"
      componentName="layoutComponent"
      :options="options"
      type="Setting"
      :rect_id="rect_id"
      :container_id="container_id"
    />
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "../publicSetting/controlWidthAndSizeAndZindex.vue"
import defaultBgImage from "../../../assets/images/default_image.png"
import elementPluginSetting from "../publicSetting/elementPluginSetting.vue"
import emptyLayoutComponent from "../emptyLayoutComponentBigScreen/emptyLayoutComponent.vue"
import { withMethodsHistoryCombine } from "utils/revork"
import { checkIrregularLayout } from "utils"
import SliderSelect from "modules/components/sliderSelect.vue"
import { CATEGORY_MODE } from "@/consts"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    emptyLayoutComponent,
    SliderSelect
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3", "9", "10"],
      allCollapseNames: ["4", "6", "7"],
      collapseActiveNames: ["1", "2", "3", "9", "10"],
      defaultBgImage: defaultBgImage,
      isInitLen: false,
      shapeChecked: true,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../assets/images/dotted-1.png")
        }
      ],
      displayPositionList: [
        {
          title: "上",
          label: "top"
        },
        {
          title: "下",
          label: "bottom"
        },
        {
          title: "左",
          label: "left"
        },
        {
          title: "右",
          label: "right"
        }
      ],
      displayPositionClassList: [
        {
          class: "signal_tb",
          label: "top"
        },
        {
          class: "signal_bt",
          label: "bottom"
        },
        {
          class: "signal_lr",
          label: "left"
        },
        {
          class: "signal_rl",
          label: "right"
        }
      ],
      top_status: true,
      contextPath: "",
      scrollTypeList: [
        {
          label: "手动",
          value: "manual"
        },
        {
          label: "自动",
          value: "auto",
          tip: "仅支持排列为1行或1列时使用",
          disabled: true
        }
      ],
      scrollDirectionList: [
        {
          value: "horizontal",
          icon: "icon-portal-direction-h"
        },
        {
          value: "vertical",
          icon: "icon-portal-direction-v"
        }
      ]
    }
  },
  watch: {
    "options.reload": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$changeOptionsEV(false, "reload", false)
            }, 100)
          })
        }
      }
    },
    singleRowOrColFlag: {
      immediate: true,
      handler(n) {
        if(n === 1) {
          this.$changeOptionsEV(true, "scorllType", false, false, false, true)
        }
        if(n === 2) {
          this.$changeOptionsEV("vertical", "scorllType", false, false, false, true)
        }
      }
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    this.initDisplaySetting()
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    opacity: {
      get() {
        return this.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    isDraggable() {
      if (this.options && !this.options.hasOwnProperty("draggable")) {
        return true
      }
      return this.options.draggable
    },
    showLayoutSetting() {
      if (this.options.hasOwnProperty("showLayoutSetting") === false) return true
      return this.options.showLayoutSetting
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    displayPositionDataModel() {
      const titleOptions = this.options.titleOptions
      // 先给一个默认值
      let arr = [
        {
          type: "classification",
          position: "top",
          directionIndex: 0,
          elementInLayoutId: 3
        },
        {
          type: "pagination",
          position: "bottom",
          directionIndex: 1,
          elementInLayoutId: 0
        },
        {
          type: "more",
          position: "top",
          directionIndex: 0,
          elementInLayoutId: 0
        }
      ]
      for (let i = 0; i < titleOptions.length; i++) {
        for (let j = 0; j < titleOptions[i].elementOptions.length; j++) {
          let position = ["top", "bottom", "left", "right"]
          let data = {
            type: titleOptions[i].elementOptions[j].type,
            position: position[i],
            directionIndex: i,
            elementInLayoutId: titleOptions[i].elementOptions[j].elementInLayoutId
          }
          switch (titleOptions[i].elementOptions[j].type) {
            // case "title":
            //   arr[0] = data
            //   break
            // case "subTitle":
            //   arr[1] = data
            //   break
            case "classification":
              arr[0] = data
              break
            case "pagination":
              arr[1] = data
              break
            // case "more":
            //   arr[3] = data
            //   break
            default:
          }
        }
      }
      return arr
    },
    disableSetColAndRow() {
      return this.hasProperty(this.options, "disableSetColAndRow")
    },
    displayTypeList() {
      let titleOptions = this.options.titleOptions
      if (this.options.name == "搜索") return
      if (this.options.pluginName && this.options.pluginName[0] == "loginLayoutComponent") return
      if (this.options.pluginName && this.options.pluginName[0] == "loginEngineComponentPlugin") return
      return [
        {
          select: titleOptions[this.displayPositionDataModel[0].directionIndex].elementOptions.find(
            it => it.elementInLayoutId === this.displayPositionDataModel[0].elementInLayoutId
          )?.isShow,
          title: "显示分类",
          type: "classification"
        },
        {
          select:
            titleOptions[this.displayPositionDataModel[1].directionIndex].elementOptions.find(
              it => it.elementInLayoutId === this.displayPositionDataModel[1].elementInLayoutId
            )?.isShow || false,
          title: "显示分页",
          type: "pagination"
        },
        {
          select: titleOptions[this.displayPositionDataModel[2].directionIndex].elementOptions.find(
            it => it.elementInLayoutId === this.displayPositionDataModel[2].elementInLayoutId
          )?.isShow,
          title: "显示更多按钮",
          type: "more"
        }
      ]
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    borderChecked: {
      get() {
        return this.borderWidth !== 0
      },
      set(val) {
        if (val) {
          this.borderWidth = 1
        } else {
          this.borderWidth = 0
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options ? this.options.borderColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderShadowChecked: {
      get() {
        return this.boxShadowColor !== "rgba(0, 0, 0,0.5)"
      },
      set(val) {
        if (val) {
          this.boxShadowColor = "#ffffff"
        } else {
          this.boxShadowColor = "rgba(0, 0, 0,0.5)"
        }
      }
    },
    boxShadowColor: {
      get() {
        return this.options ? this.options.boxShadowColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    clipSize: {
      get() {
        return this.options ? this.options.clipSize : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    repeatType: {
      get() {
        return this.options ? this.options.repeatType : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.options ? this.options.alignType : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    topNavPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavPaddingTypeFlag")) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingTypeFlag", "topNavPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    pageType() {
      return this.$store.state.states.getDataPageIds.pageType
    },
    contentWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "contentWidth", "contentWidth", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentWidth", false)
      }
    },
    showScorll: {
      get() {
        return this.options.showScorll || this.options.turnOnScroll
      },
      set(newVal) {
        if (newVal === false) {
          this.$changeOptionsEV([100, false, newVal], ["contentWidth", "turnOnScroll", "showScorll"], false)
        } else {
          this.$changeOptionsEV([false, newVal], ["turnOnScroll", "showScorll"], false)
        }
      }
    },
    scorllType: {
      get() {
        return this.options.hasOwnProperty("scorllType") ? this.options.scorllType : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "scorllType", false)
      }
    },
    isLoginEngine() {
      return this.options.pluginName && this.options.pluginName[0] == "loginEngineComponentPlugin"
    },
    topHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    // 登录组件
    isLoginLayout() {
      return this.options.pluginName && this.options.pluginName[0] == "loginLayoutComponent"
    },
    singleRowOrColFlag() {
      let flag = 0
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const { regular, rowLens, colLens } = checkIrregularLayout(this.options.rows[useActiveIndex])
      if (regular && rowLens === 1 && colLens > 1) {
        flag = 1
      } else if (rowLens > 1 && colLens === 1) {
        flag = 2
      } else {
        flag = 0
      }
      // 开启了分页，不支持自动滚动
      const pagination = this.options.titleOptions[1].elementOptions.find(item => {
        return item.type === "pagination"
      })
      this.scrollTypeList[1].disabled = !(flag && !pagination?.isShow)
      return flag
    },
    scrollTypeVal: {
      get() {
        return this.options.turnOnScroll ? "auto" : "manual"
      },
      set(newVal) {
        if(newVal === "manual") {
          this.$changeOptionsEV([false, true], ["turnOnScroll", "showScorll"], false)
        }
        if(newVal === "auto") {
          this.$changeOptionsEV([true, false], ["turnOnScroll", "showScorll"], false)
        }
      }
    },
    scrollDirectionVal: {
      get() {
        return this.options.scorllType === "vertical" ? "vertical" : "horizontal"
      },
      set(newVal) {
        if(newVal === "horizontal") {
          this.scorllType = true
        }
        if(newVal === "vertical") {
          this.scorllType = "vertical"
        }
      }
    },
    hoverStopScroll: {
      get() {
        return this.options.hoverStopScroll || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverStopScroll", false)
      }
    },
    scrollSpeed: {
      get() {
        return this.options.scrollSpeed || 6000
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "scrollSpeed", false)
      }
    },
    waitTime: {
      get() {
        // 以前的单位是s，现在转成ms，加个字段标识
        let waitTime = this.options.hasOwnProperty("waitTime") ? this.options.waitTime : 1
        if(!this.options.waitTimeUnit) {
          waitTime = waitTime * 1000
          this.$changeOptionsEV(["ms", waitTime], ["waitTimeUnit", "waitTime"], false, false, false, true)
        }
        return waitTime
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "waitTime", false)
      }
    }
  },
  methods: {
    checkShowTabs(name) {
      if (typeof this.showLayoutSetting === "boolean") return this.showLayoutSetting
      return !!this.showLayoutSetting.find(it => it === name)
    },
    hasComponent(name, type) {
      try {
        require(`./plugin/${name}/${name}-${type}.vue`)
      } catch (error) {
        return false
      }
      return true
    },
    checkboxHandle(flag) {
      switch (flag) {
        case 1:
          this.shapeType = "square"
          this.borderTopLeftRadius = 0
          this.borderTopRightRadius = 0
          this.borderBottomLeftRadius = 0
          this.borderBottomRightRadius = 0
          break
        case 2:
          this.borderColor = "#FFFFFF"
          this.borderWidth = 1
          this.borderStyle = "solid"
          this.changeBorderSelection()
          break
        case 3:
          this.boxShadowColor = "#FFFFFF"
          this.boxShadowH = 0
          this.boxShadowV = 0
          this.boxShadowBlur = 0
          this.boxShadowSpread = 0
          break
        case 4:
          this.rotate = "0deg"
          break
      }
    },
    initDisplaySetting() {
      this.displayPositionDataModel.forEach((item, index) => {
        return this.options.titleOptions.some((item1, index1) => {
          return item1.elementOptions.some((item2, index2) => {
            if (item2.type == item.type) {
              item.position = item1.type
              item.elementInLayoutId = item2.elementInLayoutId
              item.directionIndex =
                item.position == "top" ? 0 : item.position == "bottom" ? 1 : item.position == "left" ? 2 : 3
              return true
            }
          })
        })
      })
    },
    checkboxDisplayHandle(index) {
      const temp = this.displayPositionDataModel[index]
      const activeLayoutTitle = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: temp.directionIndex,
        elementInLayoutId: temp.elementInLayoutId
      }
      this.$store.dispatch(this.request_prefix + "/layoutTitleDisplayIsShow", activeLayoutTitle)
    },
    judgeIsShow(data) {
      let tf = false
      data.forEach((item, index) => {
        if (item.isShow) {
          tf = true
        }
      })
      return tf
    },
    radioDisplayHandle(flag, label, newIndex) {
      const temp = this.displayPositionDataModel[flag]
      const activeLayoutTitle = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: temp.directionIndex,
        elementInLayoutId: temp.elementInLayoutId,
        position: temp.position
      }
      // 从上/下 切换到左/右  对换掉宽高
      let isDiffDirection
      if ([0, 1].indexOf(temp.directionIndex) > -1 && [0, 1].indexOf(newIndex) === -1) {
        isDiffDirection = true
      } else if ([2, 3].indexOf(temp.directionIndex) > -1 && [2, 3].indexOf(newIndex) === -1) {
        isDiffDirection = true
      }
      if (isDiffDirection) {
        let curObj = this.options.titleOptions[temp.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === temp.elementInLayoutId
        )
        let oldWidth = curObj.options.width,
          oldHeight = curObj.options.height
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: temp.directionIndex,
          elementInLayoutId: temp.elementInLayoutId,
          option_name: "width",
          option_val: oldHeight
        })
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: temp.directionIndex,
          elementInLayoutId: temp.elementInLayoutId,
          option_name: "height",
          option_val: oldWidth
        })
      }
      this.$store.dispatch(this.request_prefix + "/layoutTitleDisplay", activeLayoutTitle)
      this.initDisplaySetting()
    },
    increase() {
      this.$refs.upBtn.style.background = "#EBEBEB"
      this.top++
    },
    decrease() {
      this.$refs.downBtn.style.background = "#EBEBEB"
      this.top--
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    stop(time) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    }
  }
})
</script>

<style scoped lang="scss">
.signal_tb {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_tb .item1 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_tb .item2 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_bt .item1 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt .item2 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_lr .item1 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr .item2 {
  width: calc(100% - 24px);
  height: 62px;
  float: left;
  background: rgba(61, 130, 242, 0.1);
}
.signal_rl {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_rl .item1 {
  width: calc(100% - 24px);
  height: 62px;
  background: rgba(61, 130, 242, 0.1);
  float: left;
}
.signal_rl .item2 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.keep-all {
  word-break: keep-all;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--themeColor);
  padding: 8px 68px;
}
.childPageSettingBtn:hover {
  cursor: pointer;
}
.mr32 {
  margin-right: 32px;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  margin-left: 16px;
  .num-btn {
    display: inline-block;
    width: 38px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
    }
  }
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.setting-item {
  .set-item {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 8px;
    .title {
      width: 56px;
      margin-right: 12px;
      line-height: 32px;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      flex-shrink: 0;
    }
    .content {
      flex: 1;
      overflow: hidden;
    }
    &:last-child {
      margin-bottom: 0;
    }
    ::v-deep.slider_and_input .el-input {
      width: 66px !important;
    }
  }
}
</style>
